import {API_DOMAIN} from "../config"
import {fetchData, postData} from "../util"
/**
 * 获取黑名单列表
 * @param page 页码
 * @param value 搜索关键字
 * @returns {Promise<* | void>}
 */
export const fetchBlackList = (page, value) => {
    const club = sessionStorage.getItem('club_id')
    const endpoint = `${API_DOMAIN}/Home/MemberApi/BlackList/club_id/${club}`
    return postData(
        endpoint,
        'POST',
        JSON.stringify({
            club_id: club,
            searchInput: value,
        })
    ).then((data) => {
        return data
    })
}
/**
 * 解除黑名单
 * @param recordId 黑名单记录ID
 * @returns {Promise<unknown>}
 */
export const fetchDeleteBlackList = (recordId) => {
    const endpoint = `${API_DOMAIN}/Home/MemberApi/DeleteBlack`
    return postData(
        endpoint,
        'POST',
        JSON.stringify({
            blacklist_id: recordId
        })
    ).then((data) => {
        return data
    })
}



// WEBPACK FOOTER //
// ./src/api/blackList.js